module.exports = __webpack_public_path__ + "img/tutor3.07e2deca.png";